import React, { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  EffectExampleTable,
  EffectSectionTitle,
  ExampleTableCell,
  ExampleTableHead,
  ExampleTableRow,
  GuideSection,
  MoreButton,
  MoreCallout,
  MoreCalloutText,
  MoreCalloutTitle,
  MoreCharacterBlock,
  MoreInlineCode,
  MorePanel,
  MoreSubsection,
  MoreSubsectionText,
  MoreSubsectionTitle,
  SectionDescription,
  VisualLabel,
} from './ImportModal.styles';

const EXAMPLE_TEAM_IDS = ['teamAlpha', 'teamBeta', 'teamGamma', 'customerSupport'] as const;

const ImportReportingGroupsEffectHelpContent: FC = () => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);

  return (
    <GuideSection>
      <EffectSectionTitle>
        {t('imports.reportingGroupsHelp.effect.section.title')}
      </EffectSectionTitle>
      <SectionDescription>
        <Trans
          i18nKey="imports.reportingGroupsHelp.effect.section.description"
          components={[<MoreInlineCode key="department1" />]}
        />
      </SectionDescription>

      <VisualLabel>{t('imports.reportingGroupsHelp.effect.section.visualLabel')}</VisualLabel>
      <EffectExampleTable>
        <thead>
          <ExampleTableRow>
            <ExampleTableHead>
              {t('imports.reportingGroupsHelp.effect.section.departmentColumn')}
            </ExampleTableHead>
          </ExampleTableRow>
        </thead>
        <tbody>
          {EXAMPLE_TEAM_IDS.map(team => (
            <ExampleTableRow key={team}>
              <ExampleTableCell>
                {t(`imports.reportingGroupsHelp.effect.examples.${team}`)}
              </ExampleTableCell>
            </ExampleTableRow>
          ))}
        </tbody>
      </EffectExampleTable>

      <MoreButton
        type="button"
        aria-expanded={showMore}
        onClick={() => setShowMore(value => !value)}
      >
        <span>{showMore ? '−' : '+'}</span>
        {showMore
          ? t('imports.reportingGroupsHelp.hide')
          : t('imports.reportingGroupsHelp.showMore')}
      </MoreButton>
      {showMore ? (
        <MorePanel>
          <MoreSubsection>
            <MoreSubsectionTitle>
              {t('imports.reportingGroupsHelp.effect.more.columnNamingTitle')}
            </MoreSubsectionTitle>
            <MoreSubsectionText>
              <Trans
                i18nKey="imports.reportingGroupsHelp.effect.more.columnNamingText"
                components={[<MoreInlineCode key="department1" />]}
              />
            </MoreSubsectionText>
          </MoreSubsection>

          <MoreSubsection>
            <MoreSubsectionTitle>
              {t('imports.reportingGroupsHelp.more.charactersTitle')}
            </MoreSubsectionTitle>
            <MoreSubsectionText>
              {t('imports.reportingGroupsHelp.more.charactersText')}
            </MoreSubsectionText>
            <MoreCharacterBlock>
              {t('imports.reportingGroupsHelp.charactersBlock')}
            </MoreCharacterBlock>
          </MoreSubsection>

          <MoreCallout>
            <MoreCalloutTitle>
              {t('imports.reportingGroupsHelp.more.safeReuploadTitle')}
            </MoreCalloutTitle>
            <MoreCalloutText>
              {t('imports.reportingGroupsHelp.more.safeReuploadText')}
            </MoreCalloutText>
          </MoreCallout>
        </MorePanel>
      ) : null}
    </GuideSection>
  );
};

export default ImportReportingGroupsEffectHelpContent;
